<template>
    <div v-if="screen.active" class="splash-modal" id="splash">
        <img :src="splashImage" class="splash-image" @click="onEnter" alt="">
        <div class="splash-content">
            <h1>{{subtitle}}</h1>
            <!-- <h2>{{title.toUpperCase()}}</h2> -->
            <img :src="siteLogo" alt="">
            <p>{{content}}</p>
            <button class="button-default" @click="onEnter">{{confirm}}</button>
        </div>
    </div>
</template>

<style scoped>

    .splash-modal{
        position: absolute;
        z-index: 5;
        width: 100%;
        min-height: 100vh;
        background-color: white;
        white-space: pre-line;
        display: block;
    }

    .splash-content{
        display: flex;
        flex-direction: column;
        align-items: left;
        padding: 0 20px 20px;
        text-align: left;
    }

    .splash-content p {
        
        max-width: 640px;
        overflow:scroll;
        display: flex;
    }

    .splash-content > h1{
        font-size: 1em;
        margin: 8px;
        text-align: left;
    }

    .splash-content > h2{
        font-size: 11.5vmin;
        margin: 0;
        text-align: left;
        white-space: nowrap;
    }



    .splash-image{
        width: 100%;
        max-height: 400px;
        object-fit: cover;
        object-position: 60% 80%;
    }
    
    p::-webkit-scrollbar { width: 0 !important }

    @media screen and (min-width: 600px) {
        
        .splash-modal{
            position: absolute;
            z-index: 5;
            width: 100%;
            height: 100%;
            background-color: white;
            white-space: pre-line;
            display: flex;
            text-align: left;
        }
        

        .splash-content{
            background-color: white;
            order: 1;
            flex-grow: 2;
            max-width: 640px;
            
        }

        .splash-content > h2{
            font-size: 6vmin;
            margin: 0;
            text-align: left;
            
        }

        

        .splash-image{
            order: 2;
            max-height: none;
            min-width: 40vw;
            flex-grow: 1;
        }
    }
    
</style>

<script>

import splashImage from "@/assets/images/bg/splash_image.png";
import {Howler, Howl} from "howler";
export default {
  name: "SplashModal",
  props: {
      
  },

  data : function() {
      return {
          state : 'active',
          splashImage : splashImage
      }
  },

  computed: {
      screen : function(){
          return this.$store.state.screens.splash;
      },

      title : function () {
          return this.screen.title
      },

      siteLogo : function() {
          return this.screen.siteLogo;
      },

      subtitle : function () {
          return this.screen.subtitle
      },

      content : function() {
          return this.screen.content
      },

      confirm : function(){
          return this.screen.confirm
      },

      gallery : function(){
          return this.$store.state.screens.room.gallery;
      },

      endTransition : function(){
          return this.$store.state.endTransition;
      }

  },

  watch : {
      endTransition : function(){
          if(!this.screen.active) return;
          let transition = this.$store.state.transition;
          if(transition == "out"){
              this.$nextTick(() => {
                  this.hide();
                  this.$store.commit('setTransition', 'in');
                  this.$store.commit('setState', {name : 'room', state: 'gallery'});
              });
          }
      }
  },

  methods : {

      onEnter : function() {
          this.$store.commit('setTransition', 'out');
          this.bgm = new Howl({
            src : [this.$store.state.sound.startSound],
            autoplay : true,
            loop : false,
            volume : 0
          })
      },

      hide : function() {
          this.$store.commit('hide', 'splash');
      },

      resumeAudioContext() {
        try {
            if (Howler.ctx && Howler.ctx.state === "suspended") {
            Howler.ctx.resume();
            // Should only need to fire once
            window.removeEventListener("click", this);
            window.removeEventListener("touchend", this);
            }
        } catch (e) {
            // SoundJS context or web audio plugin may not exist
            console.error("There was an error while trying to resume the Web Audio context...");
            console.error(e);
        }
      },
  },

  mounted() {
      console.log('MOUNTED');

      this.$store.commit('checkPlatform');
      let isMobile = this.$store.state.environment.isMobile;
      
      //Chrome Audio context fix to resume the audio context on user interaction
      window.addEventListener("click", this.resumeAudioContext);
      window.addEventListener("touchend", this.resumeAudioContext);

      this.$store.commit('load', {
            assets : [].concat(isMobile ? this.gallery.mobile :  this.gallery.pano),
            onComplete : () => {
                this.$store.commit('setTransition', 'in');
            }
        });
  }
};
</script>